import src from "IMAGE";
export default { src, width: 2153, height: 700, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAASUlEQVR42j2MiwmAMAxEu0pNUvPZQ8Uk+69jo9KDxzs4uCaqu05mqDqNAePHzLhF5uUR5+1+eObniJfaGiJuLEIA0JeZCRB7PT6xrRLsSbWzDQAAAABJRU5ErkJggg=="};
